import { Col, Container, Image, Row, Stack } from "react-bootstrap"

const CompanyFunFacts = () => {
    return (
        <Stack className="company-fun-fact margin-bottom-70">
            <Container>
                <Row className="align-items-center">
                    <Col md="auto" className="company-fun-fact-column-left">
                        <span>Company Fun Fact </span>
                        <h4 className="m-0">
                            Behind the Scenes
                            Surprising Fun Facts
                            About Wiatech
                        </h4>
                    </Col>
                    <Col md="auto" className="company-fun-fact-column-right d-flex flex-wrap ms-auto">
                        <Stack className="company-fun-fact-status">
                            <Image src="/images/project-complete.png" />
                            <label>232</label>
                            <span>Project Completed</span>
                        </Stack>
                        <Stack className="company-fun-fact-status">
                            <Image src="/images/consumer-behaviour.png" />
                            <label>388</label>
                            <span>Our Happy Clients</span>
                        </Stack>
                        <Stack className="company-fun-fact-status">
                            <Image src="/images/win-awards.png" />
                            <label>250</label>
                            <span>Win Awards</span>
                        </Stack>
                    </Col>
                </Row>
            </Container>
        </Stack>
    )
}

export default CompanyFunFacts